import { Instagram, Youtube, Linkedin, ArrowUpRight, Bell } from 'lucide-react';
import { SOCIALS, ASSETS } from '../lib/products';
import { useWaitlist } from '../context/WaitlistContext';
import KrispButton from '../components/KrispButton';
import FloatingChips from '../components/FloatingChips';
import Marquee from '../components/Marquee';
import Footer from '../sections/Footer';

const ICONS = { instagram: Instagram, youtube: Youtube, linkedin: Linkedin };

export default function SocialsPage() {
  const { openWaitlist } = useWaitlist();
  return (
    <main data-testid="socials-page" className="bg-cream min-h-screen">
      <section className="relative overflow-hidden bg-cocoa text-cream">
        <div className="absolute inset-0 opacity-[0.08] bg-[repeating-linear-gradient(135deg,transparent_0_28px,#F7B500_28px_30px)]" />
        <FloatingChips count={5} />
        <div className="relative max-w-[1400px] mx-auto px-6 md:px-14 py-16 md:py-24 text-center">
          <img src={ASSETS.logo} alt="PROKRISP" className="h-12 md:h-16 mx-auto object-contain" />
          <h1 className="font-display text-[17vw] md:text-[8vw] leading-[0.85] mt-6">FOLLOW THE<br /><span className="text-kyellow">CRUNCH.</span></h1>
          <p className="text-cream/70 mt-5 max-w-lg mx-auto">Behind the roaster, flavour votes, drop dates and the occasional gym-bag chaos. Pick your platform.</p>
        </div>
      </section>
      <Marquee text="@PRO.KRISP · GO BEYOND · FOLLOW FOR THE DROP ·" />

      <section className="max-w-[1200px] mx-auto px-5 md:px-14 py-16 grid md:grid-cols-3 gap-6">
        {SOCIALS.map((s) => {
          const Icon = ICONS[s.id];
          const inner = (
            <>
              <span className="w-16 h-16 rounded-full border-2 border-cocoa flex items-center justify-center text-cream" style={{ background: s.color }}><Icon size={28} /></span>
              <p className="font-display text-4xl text-cocoa mt-6 leading-none">{s.name}</p>
              <p className="font-cond text-sm tracking-[0.25em] text-cocoa/60 mt-1">{s.handle}</p>
              <span className={`mt-6 inline-flex items-center gap-2 font-cond font-bold text-sm tracking-wider ${s.live ? 'text-kred' : 'text-cocoa/50'}`}>
                {s.live ? <>FOLLOW <ArrowUpRight size={16} /></> : <><Bell size={14} /> COMING SOON · NOTIFY ME</>}
              </span>
            </>
          );
          const cls = 'card-pop rounded-[2rem] bg-white/70 border-2 border-cocoa p-8 flex flex-col items-start text-left';
          return s.live
            ? <a key={s.id} data-testid={`social-card-${s.id}`} href={s.href} target="_blank" rel="noreferrer" className={cls}>{inner}</a>
            : <button key={s.id} data-testid={`social-card-${s.id}`} onClick={() => openWaitlist(`${s.name} LAUNCH ALERT`)} className={cls}>{inner}</button>;
        })}
      </section>

      <section className="bg-kyellow rounded-[2.5rem] mx-3 md:mx-8 px-6 md:px-14 py-14 text-center">
        <p className="font-display text-5xl md:text-7xl text-cocoa leading-none">TAG US. GET FEATURED.</p>
        <p className="text-cocoa/70 mt-3">Post your PROKRISP moment with <b>#GoBeyond</b> and <b>@pro.krisp</b>.</p>
        <a href="https://www.instagram.com/pro.krisp/" target="_blank" rel="noreferrer" className="inline-block mt-6"><KrispButton testid="socials-instagram-cta" variant="dark"><Instagram size={16} /> OPEN INSTAGRAM →</KrispButton></a>
      </section>
      <div className="mt-16"><Footer /></div>
    </main>
  );
}
